import { render, staticRenderFns } from "./CmgInput.vue?vue&type=template&id=36497fa3&scoped=true&lang=pug"
import script from "./cmg-input.ts?vue&type=script&lang=ts&external"
export * from "./cmg-input.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgInput.vue?vue&type=style&index=0&id=36497fa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36497fa3",
  null
  
)

export default component.exports